import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAnalyticsOverview, AnalyticsOverview } from '../services/adminApi';

const OverviewPage = () => {
  const { t } = useTranslation();
  const [overview, setOverview] = useState<AnalyticsOverview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAnalyticsOverview()
      .then(setOverview)
      .catch((err) => setError(err.message));
  }, []);

  const actionCards = [
    {
      title: t('pages.manageProjects'),
      description: t('pages.projectsDescription'),
      link: '/admin/projects',
    },
    {
      title: t('pages.manageJobs'),
      description: t('pages.jobsDescription'),
      link: '/admin/jobs',
    },
    {
      title: t('pages.manageApplications'),
      description: t('pages.applicationsDescription'),
      link: '/admin/applications',
    },
    {
      title: t('pages.manageContacts'),
      description: t('pages.contactsDescription'),
      link: '/admin/contacts',
    },
  ];

  return (
    <div className="page-grid">
      <div className="section-heading">
        <h2>{t('pages.adminOverviewTitle')}</h2>
        <p>{t('pages.adminOverviewSubtitle')}</p>
      </div>

      <div className="overview-hero">
        <div>
          <p>{t('common.helloName', { name: 'Admin' })}</p>
          <p className="muted">{t('common.unreadMessages', { count: 0 })}</p>
        </div>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {overview ? (
        <>
          <div className="overview-grid">
            <article className="overview-card">
              <p className="overview-card-title">{t('pages.totalProjects')}</p>
              <p className="overview-card-value">{overview.totalProjects}</p>
              <p className="overview-card-meta">{t('pages.projectsDescription')}</p>
            </article>
            <article className="overview-card">
              <p className="overview-card-title">{t('pages.openPositions')}</p>
              <p className="overview-card-value">{overview.openJobs}</p>
              <p className="overview-card-meta">{t('pages.jobsDescription')}</p>
            </article>
            <article className="overview-card">
              <p className="overview-card-title">{t('pages.contactLeads')}</p>
              <p className="overview-card-value">{overview.contactMessages}</p>
              <p className="overview-card-meta">{t('pages.contactsDescription')}</p>
            </article>
            <article className="overview-card">
              <p className="overview-card-title">{t('pages.applications')}</p>
              <p className="overview-card-value">{overview.jobApplications}</p>
              <p className="overview-card-meta">{t('pages.applicationsDescription')}</p>
            </article>
          </div>

          <div className="overview-actions-grid">
            {actionCards.map((action) => (
              <div key={action.link} className="overview-action-card">
                <div>
                  <p className="overview-card-title">{action.title}</p>
                  <p className="overview-card-meta">{action.description}</p>
                </div>
                <Link to={action.link} className="btn btn-secondary">
                  {t('common.manage')}
                </Link>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div>{t('pages.loadingOverview', 'Loading overview...')}</div>
      )}
    </div>
  );
};

export default OverviewPage;
